import { useEffect } from "react";

/**
 * Shared portal-modal bits — Escape closes, body has the modal
 * mounted. Extracted so `<CoachModal>` (form modal) and
 * `<ConfirmDialog>` (one-shot confirm) can share the same Escape
 * + (eventually) focus-trap behavior without duplicating it.
 *
 * Today this just wires the Escape handler. A future polish pass
 * can extend it with focus-trap / inert-background / scroll-lock
 * — every modal primitive in the app gets them in one place.
 */
export function useOneShotModal(onClose: () => void): void {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);
}
